

// import styles from '../../styles/StickerTagInfo.module.css'
import '../../styles/tagSelect.css'
import { FormattedMessage, useIntl } from 'react-intl'
import { getEmojinameByEmojiIndex } from '../../utils/findEmoji'
import { getLanguage } from '../../data/languageCascaderData'
import { useEveryStickerCategory } from '../../hooks/reactQuery/useEveryStickerCategory'

export default function StickerTagInfo({
  textLang,
  emojiCategories,
}: {
  textLang: string | undefined | null
  emojiCategories: number[] | null
}) {
  const intl = useIntl()
  const { data: everyStickerCategory, isLoading: stickerCategoryLoading } =
    useEveryStickerCategory()
  if (stickerCategoryLoading) return <></>
  return (
    <div className="sticker-withtag-wrapper tag-list">
      <div className="tag-list-wrapper">
        <div className="tag-section">
          <div className="side-head">
            <FormattedMessage id="SelectTag.taginfo.tag" />
          </div>
          <div className="selected-tag">
            {emojiCategories?.map((emojiIndex) => {
              const emojiAndName = getEmojinameByEmojiIndex(
                emojiIndex,
                everyStickerCategory,
              )
              if (!emojiAndName) {
                return null
              }
              return (
                <div key={emojiAndName.name_en}>
                  {emojiAndName.emoji}
                  <span style={{ marginLeft: 6 }}>
                    {intl.locale === 'ko'
                      ? emojiAndName.name_ko
                      : emojiAndName.name_en}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
        <div className="divider" />
        <div className="lang-section">
          <div>
            <FormattedMessage id="SelectTag.taginfo.lang" />
          </div>
          {textLang && (
            <div className="selected-language">
              {textLang === 'IMAGE_ONLY' ? (
                <FormattedMessage id="Upload.PkgCreation.createPack.packLanguage.imageOnly" />
              ) : (
                <span style={{ marginLeft: 6 }}>{getLanguage(textLang)}</span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
